export const expressiveSpring = {
  type: 'spring',
  stiffness: 420,
  damping: 32,
  mass: 0.86
};

export const expressiveSlowSpring = {
  type: 'spring',
  stiffness: 240,
  damping: 28,
  mass: 1
};

export const effectsSpring = {
  type: 'spring',
  stiffness: 520,
  damping: 38,
  mass: 0.72
};

export const pageMotion = {
  initial: { opacity: 0, y: 18, scale: 0.985, filter: 'blur(10px)' },
  animate: { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)' },
  exit: { opacity: 0, y: -10, scale: 0.992, filter: 'blur(8px)' },
  transition: expressiveSpring
};

export const listContainer = {
  hidden: { opacity: 1 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.045,
      delayChildren: 0.04
    }
  }
};

export const listItem = {
  hidden: { opacity: 0, y: 16, scale: 0.98 },
  show: { opacity: 1, y: 0, scale: 1, transition: expressiveSpring }
};
